/** Full-screen splash shown while the auth store is hydrating. */
export function AuthLoading() {
  return (
    <div className="flex h-full min-h-screen items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <img src="/favicon.svg" alt="" className="h-12 w-12 animate-pulse rounded-lg shadow-sm" />
        <p className="text-sm font-medium text-slate-500">Loading…</p>
      </div>
    </div>
  );
}
